module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_5012.1b2ab210.png";